const DATES_AVAILABILITY = {
  title: 'Gestor de Pedidos',
  greetings: {
    title: 'Olá,',
    subtitle:
      'Aqui você pode selecionar as datas em que a sua loja não está disponível para a venda de Chopp',
  },
  datesAvailability: {
    title:
      'Selecione as datas que você deseja que sua loja não esteja disponível para venda no app do Zé Delivery',
    subtitle: 'Seleção de Datas Indisponíveis',
    clearButtonLabel: 'Limpar Datas Indisponiveis',
    saveButtonLabel: 'Salvar',
  },
  buttons: {
    clearDates: 'Limpar Datas Indisponíveis',
    saveDates: 'Salvar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Salvar',
  },
  modals: {
    confirmDates: {
      title: 'Porque você vai bloquear essa janela de entrega?',
      subtitle: 'Descreva o motivo com o máximo de detalhes.',
    },
    clearDates: {
      title: 'Tem certeza que deseja resetar as datas bloqueadas?',
      subtitle: 'Essa ação não poderá ser desfeita.',
    },
  },
  toastMessages: {
    success: 'Janela de bloqueio atualizada',
    error: 'Ops! Ocorreu um erro ao atualizar janela',
  },
}

export default DATES_AVAILABILITY
